import { z } from 'zod';
/**
 * YARA excluded extension response schema
 */
export const yaraExclusionSchema = z.object({
    id: z.string(),
    extensionId: z.string(),
    reason: z.string().nullable(),
    excludedBy: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/**
 * List of YARA excluded extensions response schema
 */
export const yaraExclusionsListSchema = z.array(yaraExclusionSchema);
/**
 * Add YARA exclusion request schema
 */
export const addYaraExclusionBodySchema = z.object({
    extensionId: z.string().min(1, 'Extension ID is required'),
    reason: z.string().optional(),
});
/**
 * Add YARA exclusion response schema (same as exclusion schema)
 */
export const addYaraExclusionResponseSchema = yaraExclusionSchema;
//# sourceMappingURL=yara-exclusions.js.map